const doc = [({"en":({"js":({"admin":({"sheet_sizes":({"select":({"choose_sheet_size":"Choose sheet size"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;